import type { ReviewableFormInputProps } from "./types";
import { useFieldsStatuses, useRequestedChangeFields } from "./actions";

export const useReviewableFormInput = (param: Pick<
    ReviewableFormInputProps,
    | 'setFieldValue'
    | 'setFieldTouched'
    | 'values'
    | 'name'
>) => {
    const {
        onApprove,
        onReject
    } = useFieldsStatuses(param);

    const {
        getComments,
        onSubmitComments,
        onAddComment,
        onChange
    } = useRequestedChangeFields(param);

    return {
        getComments,
        onSubmitComments,
        onAddComment,
        onChange,
        onApprove,
        onReject
    };
};

export default useReviewableFormInput;
